function getCta(dto) {
    if ((dto === null || dto === void 0 ? void 0 : dto.data) && dto.data.length > 0) {
        var isButton = dto.data[0].mimeType === 'button';
        return isButton ? dto.data[0].data.cta : undefined;
    }
}
export default getCta;
